module.exports = __webpack_public_path__ + "img/icon-home.73a0ecb9.svg";